import React, { useState } from "react";
import "./CareerSection.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

export const GradIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Courses-black.svg"
      : "/Image/Hero/Courses.svg";

  return <img src={src} alt="grad icon" width={size} height={size} />;
};

export const BriefcaseIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Jobs-black.svg"
      : "/Image/Hero/Jobs.svg";

  return <img src={src} alt="briefcase icon" width={size} height={size} />;
};

export const ProfileIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Profile-black.svg"
      : "/Image/Hero/Profile.svg";

  return <img src={src} alt="profile icon" width={size} height={size} />;
};

export const TickIcon = () => {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        backgroundColor: "#EE2F75",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-hidden="true"
    >
      <img src="/Image/Hero/Tick2.svg" width="14px" height="14px" alt="" />
    </div>
  );
};

export default function CareerSection() {
  const { t } = useTranslation();
  const [active, setActive] = useState("courses");
  const history = useHistory();

  const tabOrder = {
    courses: 0,
    jobs: 1,
    profile: 2,
  };

  const [direction, setDirection] = useState("right");

  const handleLearnMore = () => {
    history.push({
      pathname: "/signup",
      state: { detail: "INDIVIDUAL" },
    });
  };

  const handleTabChange = (nextTab) => {
    if (nextTab === active) return;

    const currentIndex = tabOrder[active];
    const nextIndex = tabOrder[nextTab];

    setDirection(nextIndex > currentIndex ? "right" : "left");
    setActive(nextTab);
  };

  const renderContent = () => {
    switch (active) {
      case "courses":
        return {
          title: t("home.career.courses.title"),
          desc: t("home.career.courses.desc"),
          benefits: [
            t("home.career.courses.benefits.0"),
            t("home.career.courses.benefits.1"),
            t("home.career.courses.benefits.2"),
            t("home.career.courses.benefits.3"),
          ],
          cards: [
            {
              ico: <GradIcon size="30" color={active === "courses" ? "white" : "black"} />,
              title: t("home.career.courses.cards.0.title"),
              text: t("home.career.courses.cards.0.text"),
            },
            {
              ico: <GradIcon size="30" color={active === "courses" ? "white" : "black"} />,
              title: t("home.career.courses.cards.1.title"),
              text: t("home.career.courses.cards.1.text"),
            },
            {
              ico: <GradIcon size="30" color={active === "courses" ? "white" : "black"} />,
              title: t("home.career.courses.cards.2.title"),
              text: t("home.career.courses.cards.2.text"),
            },
          ],
        };

      case "jobs":
        return {
          title: t("home.career.jobs.title"),
          desc: t("home.career.jobs.desc"),
          benefits: [
            t("home.career.jobs.benefits.0"),
            t("home.career.jobs.benefits.1"),
            t("home.career.jobs.benefits.2"),
            t("home.career.jobs.benefits.3"),
          ],
          cards: [
            {
              ico: <BriefcaseIcon size="26" color={active === "jobs" ? "white" : "black"} />,
              title: t("home.career.jobs.cards.0.title"),
              text: t("home.career.jobs.cards.0.text"),
            },
            {
              ico: <BriefcaseIcon size="26" color={active === "jobs" ? "white" : "black"} />,
              title: t("home.career.jobs.cards.1.title"),
              text: t("home.career.jobs.cards.1.text"),
            },
            {
              ico: <BriefcaseIcon size="26" color={active === "jobs" ? "white" : "black"} />,
              title: t("home.career.jobs.cards.2.title"),
              text: t("home.career.jobs.cards.2.text"),
            },
          ],
        };

      case "profile":
        return {
          title: t("home.career.profile.title"),
          desc: t("home.career.profile.desc"),
          benefits: [
            t("home.career.profile.benefits.0"),
            t("home.career.profile.benefits.1"),
            t("home.career.profile.benefits.2"),
            t("home.career.profile.benefits.3"),
          ],
          cards: [
            {
              ico: <ProfileIcon size="23" color={active === "profile" ? "white" : "black"} />,
              title: t("home.career.profile.cards.0.title"),
              text: t("home.career.profile.cards.0.text"),
            },
            {
              ico: <ProfileIcon size="23" color={active === "profile" ? "white" : "black"} />,
              title: t("home.career.profile.cards.1.title"),
              text: t("home.career.profile.cards.1.text"),
            },
            {
              ico: <ProfileIcon size="23" color={active === "profile" ? "white" : "black"} />,
              title: t("home.career.profile.cards.2.title"),
              text: t("home.career.profile.cards.2.text"),
            },
          ],
        };

      default:
        return {};
    }
  };

  const { title, desc, benefits, cards } = renderContent();

  return (
    <section
      className="career-section"
      role="region"
      aria-label={t("home.career.ariaLabel", "Accelerate your career")}
    >
      <div className="career-inner" style={{ zIndex: 2 }}>
        <header className="career-header">
          <h2 className="career-title">
            {t("home.career.header.line1")} <span className="accent">{t("home.career.header.accent")}</span>
            <br />
            <span className="accent">{t("home.career.header.line2")}</span>
          </h2>
          <p className="career-sub">{t("home.career.header.sub")}</p>
        </header>

        {/* Tabs */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <nav className="career-tabs" role="tablist" aria-label={t("home.career.tabs.aria", "Career sections")}>
            <button
              className={`tab ${active === "courses" ? "active" : ""}`}
              onClick={() => handleTabChange("courses")}
              role="tab"
              aria-selected={active === "courses"}
              aria-controls="courses-panel"
            >
              <span className="tab-ico">
                <GradIcon size={22} color={active === "courses" ? "white" : "black"} />
              </span>
              {t("home.career.tabs.courses")}
            </button>

            <button
              className={`tab ${active === "jobs" ? "active" : ""}`}
              onClick={() => handleTabChange("jobs")}
              role="tab"
              aria-selected={active === "jobs"}
              aria-controls="jobs-panel"
            >
              <span className="tab-ico">
                <BriefcaseIcon size={22} color={active === "jobs" ? "white" : "black"} />
              </span>
              {t("home.career.tabs.jobs")}
            </button>

            <button
              className={`tab ${active === "profile" ? "active" : ""}`}
              onClick={() => handleTabChange("profile")}
              role="tab"
              aria-selected={active === "profile"}
              aria-controls="profile-panel"
            >
              <span className="tab-ico">
                <ProfileIcon size={22} color={active === "profile" ? "white" : "black"} />
              </span>
              {t("home.career.tabs.profile")}
            </button>
          </nav>
        </div>

        {/* Shared layout — media + info */}
        <div className="career-main">
          <div className="career-media">
            <div className="video-placeholder" aria-hidden="true">
              <div className="play-circle">
                <div className="play-triangle" />
              </div>
            </div>
          </div>

          <aside className="career-info">
            <div
              key={active}
              className={`career-info-panel ${
                direction === "right" ? "slide-in-right" : "slide-in-left"
              }`}
            >
              <h3>{title}</h3>
              <p className="career-info-desc">{desc}</p>

              <ul className="benefits-list">
                {benefits?.map((item, i) => (
                  <li key={i}>
                    <span className="tick-icon">
                      <TickIcon />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="btn-primary-career" onClick={handleLearnMore}>
                {t("home.career.learnMore", "Learn More")}{" "}
                <img
                  src="/Image/Hero/learn more arrow.svg"
                  className="learn-arrow"
                  width="22px"
                  height="20px"
                  alt=""
                />
              </button>
            </div>
          </aside>
        </div>

        {/* Mini-cards row */}
        <div className="card-row">
          {cards?.map((card, i) => (
            <article className="mini-card" key={i}>
              <div className="mini-ico">{card.ico}</div>
              <h4>{card.title}</h4>
              <p>{card.text}</p>
              {/* <a className="mini-link">
                {t("home.career.explore", "Explore")}
                <svg width="16" height="16" style={{ marginLeft: 5, paddingBottom: 3 }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6969 10.125H0V7.875H13.6969L7.39688 1.575L9 0L18 9L9 18L7.39688 16.425L13.6969 10.125Z" fill="#EE2F75"/>
                </svg>
              </a> */}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
